import { css, cx } from '@linaria/core'
import type { FC } from 'react'
import { fragments, style } from '#styles'

const tabHeaderClass = css`
  z-index: 2;
  cursor: pointer;
  user-select: none;
  position: relative;
  box-sizing: border-box;
  appearance: none;
  padding: 0 8px;
  height: 40px;
  max-height: 40px;
  background-color: transparent;
  border: none;
  text-align: center;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  
  border-bottom: 2px solid transparent;
  transition: border-bottom 0.25s ease;

  > ._content {
    margin: 0;
    display: flex;
    ${fragments.textStyle.tab.m}
    color: ${style.themeColors.textDefault};
    line-height: 100%;

    align-items: center;

    > label {
      cursor: pointer;

      > span {
        ${fragments.textStyle.tab.m}
      }
    }
    
    > ._tab-menu {
    }
  }

  &:focus-visible {
    outline: 1px solid ${style.themeColors.lineImportant};
    outline-offset: -1px;
  }
  
  &:hover::after {
    opacity: 1;
  }

  &._justified {
    width: 100%;
  }

  &._disabled,
  :disabled {
    pointer-events: none;
    color: ${style.themeColors.textDisabled};

    > ._content {
      color: ${style.themeColors.textDisabled};
    }
  }



  &._active, &:hover {
    border-bottom: 2px solid ${style.themeColors.textImportant};
    
    &::after {
      opacity: 1;
      background-color: ${style.themeColors.textImportant};
    }

    > ._content {
      color: ${style.themeColors.textImportant};
    }
  }

  &._secondary {
    &::after {
      background-color: ${style.themeColors.lineInput};
      transition: 0.25s background-color ease;
    }
    
    &:hover {
      &::after {
        background-color: ${style.themeColors.lineImportant};
      }
    }

    > ._content {
      color: ${style.themeColors.textDefault};
    }
  }
`

interface TabHeaderProps {
  children?: React.ReactNode
  active: boolean
  secondary?: boolean
  justified?: boolean
  disabled?: boolean
}

export const TabHeader: FC<TabHeaderProps & React.HTMLProps<HTMLButtonElement>> = ({
  children,
  active = false,
  justified = false,
  secondary = false,
  disabled = false,
  ...props
}) => {
  const classCombine = cx(
    props.className,
    tabHeaderClass,
    active && '_active',
    secondary && '_secondary',
    justified && '_justified',
    disabled && '_disabled',
  )

  return (
    <button ref={props.ref} {...props} className={classCombine} type="button" role="tab" aria-selected={active} disabled={disabled}>
      <div className="_content">{children}</div>
    </button>
  )
}
